const urlHelper = {
  getPaymentdetails(payload: any) {
    return `/odin/v2/demands/token-detail?demandId=${payload.demandId}&opCode=${payload.opCode}`;
  },
  getTokenDetailsv2(demandID: number) {
    return `/rest/tesseract/v1/token?demandId=${demandID}`;
  },
  initiatePayment(payload: any) {
    return `rest/tesseract/v1/payment/wallet/initiate-recharge`;
  },
  initiatePaymentStatus(payload: any) {
    return `rest/tesseract/v1/payment/wallet/complete-recharge`;
  },
  getTokenDetails(demandID: number) {
    return `/rest/tesseract/v1/demand/${demandID}/token-details`;
  },
  getWalletBalance() {
    return `/rest/tesseract/v1/payment/wallet`;
  },
  postConfirmDemand(demandID: string) {
    return `/rest/tesseract/v1/token/${demandID}/vehicle-details`;
  },
  initiatePaymentv2(demandID: string) {
    return `/rest/tesseract/v1/demand/${demandID}/initiate-token`;
  },
  payTokenAmt(demandID: string) {
    return `/rest/tesseract/v1/token/${demandID}/pay-token`;
  },
  operatorWebMarketPlaceConfig() {
    return `/odin/operator-web/services/info/app-config`;
  },
  tokenVehicleDetails(demandID: string) {
    return `rest/tesseract/v1/demand/${demandID}/vehicles`;
  },
  vehicleKycDetails(id: string) {
    // GET  /tesseract/v1/vehicle/{id}
    return `rest/tesseract/v1/vehicle/${id}`;
  },
  fetchContactInfo: (demandId: string) => `/rest/tesseract/v1/token/${demandId}/phonebook-driver-info`,
};

export default urlHelper;
